import { render, staticRenderFns } from "./dynamic_issues_extra_tabs.vue?vue&type=template&id=453c26a1&scoped=true&lang=pug&"
import script from "./dynamic_issues_extra_tabs.vue?vue&type=script&setup=true&lang=js&"
export * from "./dynamic_issues_extra_tabs.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./dynamic_issues_extra_tabs.vue?vue&type=style&index=0&id=453c26a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453c26a1",
  null
  
)

export default component.exports